import { DEBUG } from '../config';
import { addLogDispatch } from '../redux/actions/logs';
import { dataLog } from './logging';
import { addVideoStreamDispatch, removeVideoStreamDispatch } from '../redux/actions/application';
import { pointer } from '../components/Icons/Pointer';

/*globals apiRTC*/

/**
 * removes the current stream container
 */
export const removeStreamContainer = () => {
    const elm = document.getElementById('stream');
    if (elm) {
        removeVideoStreamDispatch();
        elm.remove();
    }
};

/**
 * add the video stream to a dom video object
 * @param {object} stream video stream object
 * @param {boolean} showControls
 */
export const addCallerVideoStreamInDiv = (stream, showControls, showPointer = true, elementId = 'videoContainer__inner') => {
    const streamDiv = document.getElementById(elementId);
    streamDiv.innerHTML = '';

    const mediaElt = document.createElement('video');
    mediaElt.id = 'stream';
    mediaElt.autoplay = true;
    mediaElt.muted = true;
    mediaElt.className = 'videoElement';
    mediaElt.controls = showControls;
    mediaElt.playsinline = true;

    const pointerElement = document.createElement('div');
    pointerElement.id = 'pointer';
    pointerElement.className = 'pointerElement';
    pointerElement.innerHTML = pointer;

    let funcFixIoS = () => {
        let promise = mediaElt.play();

        if (promise !== undefined) {
            promise
                .then(function () {
                    // Autoplay started!
                    if (DEBUG) addLogDispatch(['Autoplay started']);

                    document.removeEventListener('touchstart', funcFixIoS);
                })
                .catch(error => {
                    // Autoplay was prevented.
                    if (DEBUG) addLogDispatch(['Autoplay was prevented']);
                    dataLog({
                        message: 'Autoplay was prevented.',
                        eventId: 'AUTOPLAY_PREVENT',
                    });
                });
        }
    };

    window.addEventListener('pauseVideo', () => {
        mediaElt.controls = false;
        mediaElt.pause();
    });

    window.addEventListener('unpauseVideo', () => {
        mediaElt.controls = showControls;
        mediaElt.play();
    });

    stream.attachToElement(mediaElt);
    streamDiv.appendChild(mediaElt);
    if (showPointer) {
        streamDiv.appendChild(pointerElement);
    }
    addVideoStreamDispatch();

    let playPromise = mediaElt.play();
    if (playPromise !== undefined) {
        playPromise
            .then(function () {
                if (DEBUG) addLogDispatch(['Autoplay started']);
            })
            .catch(error => {
                if (apiRTC.osName === 'iOS') {
                    if (DEBUG) addLogDispatch(['iOS : Autoplay was prevented, activating touch event to start media play']);
                    dataLog({
                        message: 'Autoplay was prevented.',
                        eventId: 'AUTOPLAY_PREVENT',
                    });

                    document.addEventListener('touchstart', funcFixIoS);
                } else {
                    if (DEBUG) addLogDispatch(['Autoplay was prevented']);
                    dataLog({
                        message: 'Autoplay was prevented.',
                        eventId: 'AUTOPLAY_PREVENT',
                    });
                }
            });
    }
};

/**
 * setup eventlisteners for stream errors
 * @param {object} call
 */
export const streamHandling = call => {
    call.on('localStreamAvailable', stream => {
        if (DEBUG) addLogDispatch(['localStreamAvailable']);
        addCallerVideoStreamInDiv(stream, false);
        stream.on('stopped', () => {
            if (DEBUG) addLogDispatch(['Stream stopped']);
            removeStreamContainer();
        });
    })
        .on('streamAdded', stream => {
            if (DEBUG) addLogDispatch(['stream added']);
            addCallerVideoStreamInDiv(stream, true);
            stream.on('stopped', () => {
                if (DEBUG) addLogDispatch(['Stream stopped']);
                removeStreamContainer();
            });
        })
        .on('streamRemoved', e => {
            if (DEBUG) addLogDispatch(['stream removed', e]);
        })
        .on('userMediaError', e => {
            if (DEBUG) addLogDispatch(['user media error', e]);
        })
        .on('desktopCapture', e => {
            if (DEBUG) addLogDispatch(['desktopCapture event : ', e]);
        })
        .on('hangup', () => {
            if (DEBUG) addLogDispatch(['hangup']);
        });
};

/**
 * add the video stream to a dom video object
 * @param {object} stream video stream object
 * @param {boolean} showControls
 */
export const addDispatcherVideoStreamInDiv = (stream, showControls) => {
    const streamDiv = document.getElementById('bidiContainer__inner');
    streamDiv.innerHTML = '';

    const mediaElt = document.createElement('video');
    mediaElt.id = 'stream';
    mediaElt.autoplay = true;
    mediaElt.muted = true;
    mediaElt.className = 'videoElement';
    mediaElt.controls = showControls;
    mediaElt.playsinline = true;

    let funcFixIoS = () => {
        let promise = mediaElt.play();

        if (promise !== undefined) {
            promise
                .then(function () {
                    // Autoplay started!
                    if (DEBUG) addLogDispatch(['Autoplay started']);

                    document.removeEventListener('touchstart', funcFixIoS);
                })
                .catch(error => {
                    // Autoplay was prevented.
                    if (DEBUG) addLogDispatch(['Autoplay was prevented']);
                    dataLog({
                        message: 'Autoplay was prevented.',
                        eventId: 'AUTOPLAY_PREVENT',
                    });
                });
        }
    };

    window.addEventListener('pauseVideo', () => {
        mediaElt.controls = false;
        mediaElt.pause();
    });

    window.addEventListener('unpauseVideo', () => {
        mediaElt.controls = showControls;
        mediaElt.play();
    });

    stream.attachToElement(mediaElt);
    streamDiv.appendChild(mediaElt);

    // TODO: Replace this with addBidiVideoStream()
    // addVideoStreamDispatch();

    let playPromise = mediaElt.play();
    if (playPromise !== undefined) {
        playPromise
            .then(function () {
                if (DEBUG) addLogDispatch(['Autoplay started']);
            })
            .catch(error => {
                if (apiRTC.osName === 'iOS') {
                    if (DEBUG) addLogDispatch(['iOS : Autoplay was prevented, activating touch event to start media play']);
                    dataLog({
                        message: 'Autoplay was prevented.',
                        eventId: 'AUTOPLAY_PREVENT',
                    });

                    document.addEventListener('touchstart', funcFixIoS);
                } else {
                    if (DEBUG) addLogDispatch(['Autoplay was prevented']);
                    dataLog({
                        message: 'Autoplay was prevented.',
                        eventId: 'AUTOPLAY_PREVENT',
                    });
                }
            });
    }
};


export const addStreamToConferenceUserContainer = (stream, elementId, clear = false) => {
    const streamDiv = document.getElementById(elementId);

    if (clear) {
        streamDiv.innerHTML = '';
    }

    if (typeof streamDiv !== 'undefined' && streamDiv !== null) {
        var children = streamDiv.childNodes;
    }

    // Check if stream is a screen share
    if (stream.callAudioActive === false) {
        // Create new video element with controls to allow user full screen viewing
        const mediaElt = document.createElement('video');
        mediaElt.id = 'stream';
        mediaElt.autoplay = true;
        mediaElt.muted = true;
        mediaElt.className = 'videoElement';
        mediaElt.controls = false;
        mediaElt.playsinline = true;

        NodeList.prototype.forEach = Array.prototype.forEach;
        if (streamDiv !== null) {
            // Attach controls to incoming video stream
            stream.attachToElement(mediaElt);
            streamDiv.appendChild(mediaElt);

            // Workaround to prevent pausing of screen share stream
            let video = document.querySelector('video');
            video.addEventListener('pause', e => {
                video.play();
                e.preventDefault();
            });
        }
    }

    if (typeof streamDiv !== 'undefined' && streamDiv !== null) {
        stream.addInDiv(elementId, 'stream-media-' + stream.streamId, {}, false);

        // Remove unused stream elements from id if any exist
        children = streamDiv.childNodes;
        children.forEach(function (videoElement) {
            if (videoElement.nodeName.toLowerCase() === 'video') {
                if (videoElement.id !== 'stream') {
                    streamDiv.removeChild(videoElement);
                }
            }
        });
    }
};